import { render, staticRenderFns } from "./OrganizationMenu.vue?vue&type=template&id=5f0d54ac&scoped=true"
import script from "./OrganizationMenu.vue?vue&type=script&lang=js"
export * from "./OrganizationMenu.vue?vue&type=script&lang=js"
import style0 from "./OrganizationMenu.vue?vue&type=style&index=0&id=5f0d54ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0d54ac",
  null
  
)

export default component.exports